module.exports = __webpack_public_path__ + "static/media/badge-sheriff.67ba7d54.svg";